import React, { FC, useCallback, useState } from 'react';
import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import Layout1 from '../components/layout';
import SliceZone from '../components/SliceZone';
import { H1, P } from '../components/TahoraUI/Typography';
import PricingFooter from '../components/pricingFooter';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Layout from '../components/TahoraUI/Layout';
import Footer from '../components/Footer';
import Flex, {
  desktopOnlyDisplay,
  mobileOnlyDisplay,
} from '../components/TahoraUI/Flex';

export const query = graphql`
  query PricingQuery($id: String) {
    prismic {
      allFooters {
        edges {
          node {
            shape
            logo
            footer_social_icons {
              footer_social_icon_image
              footer_social_icon_link {
                ... on PRISMIC__ExternalLink {
                  url
                }
              }
            }
            footer_column_1_heading
            footer_column_2_heading
            footer_column_3_heading
            footer_column_4_heading
            footer_copyright
            footer_form_heading
            footer_column_2_content {
              footer_column_navigation_featured
              footer_column_navigation_label
              footer_column_navigation_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
            footer_column_3_content {
              footer_column_navigation_featured
              footer_column_navigation_label
              footer_column_navigation_link {
                ... on PRISMIC__ExternalLink {
                  url
                }
              }
            }
            footer_column_4_content {
              footer_column_navigation_featured
              footer_column_navigation_label
              footer_column_navigation_link {
                ... on PRISMIC__ExternalLink {
                  url
                }
              }
            }
            footer_column_1_content {
              footer_column_navigation_featured
              footer_column_navigation_label
              footer_column_navigation_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
          }
        }
      }
      allCentral_assetss {
        edges {
          node {
            apple_app_store_badge
            apple_app_store_link {
              ... on PRISMIC__ExternalLink {
                target
                _linkType
                url
              }
            }
            google_play_store_badge
            google_play_store_link {
              ... on PRISMIC__ExternalLink {
                target
                _linkType
                url
              }
            }
            tahora_icon
            tahora_logo_dark
            tahora_logo_light
          }
        }
      }
      allPricings(id: $id) {
        edges {
          node {
            package_1_features
            package_1_subtext
            package_1_title
            package_2_features
            package_2_subtext
            package_2_title
            package_3_features
            package_3_subtext
            package_3_title
            page_title
            addon_button_link {
              ... on PRISMIC__ExternalLink {
                target
                _linkType
                url
              }
            }
            addon_button_text
            addon_features
            addon_subtitle
            addon_title
            section1_header
            section2_header
            section3_header
            section4_header
            section5_header
            section6_header
            bullet
            footer_image
            apple_logo
            google_logo
            body {
              ... on PRISMIC_PricingBodyPricing_table_feature {
                type
                fields {
                  pricing_table_feature_title
                  pricing_table_feature_title_tooltip
                  pricing_table_package_1
                  pricing_table_package_1_text
                  pricing_table_package_2
                  pricing_table_package_2_text
                  pricing_table_package_3
                  pricing_table_package_3_text
                  subheader
                }
              }
              ... on PRISMIC_PricingBodyText {
                type
                primary {
                  pricing_table_section_title
                }
              }
            }
            hero_image
            hero_text
            pricing_section_button {
              ... on PRISMIC__ExternalLink {
                target
                _linkType
                url
              }
            }
            pricing_section_button_text
            pricing_section_image
            pricing_section_image_mobile
            pricing_section_text
            pricing_section_title
            pricing_table_subtitle
            pricing_table_title
            pricing_table_title_section_1
            tahora_overview_section {
              tahora_overview_content
              tahora_overview_title
              main_card_image
              mobile_card_image
            }
          }
        }
      }
    }
  }
`;

const Pricing = props => {
  const heroImage = props.data.prismic.allPricings.edges[0].node.hero_image.url;
  const pricingTitle = props.data.prismic.allPricings.edges[0].node.page_title;
  const heroText = props.data.prismic.allPricings.edges[0].node.hero_text;
  const overview =
    props.data.prismic.allPricings.edges[0].node.tahora_overview_section;
  const allFooterInfo =
    props.data.prismic.allFooters.edges[0].node.footer_social_icons;
  const allFooterInfoA = props.data.prismic.allCentral_assetss.edges[0].node;
  const footerInfo = props.data.prismic.allFooters.edges[0].node;
  const allPriceInfo = props.data.prismic.allPricings.edges[0].node;

  <script
    async
    defer
    src="https://static.cdn.prismic.io/prismic.js?new=true&repo=tahoraweb"
  ></script>;
  return (
    <div>
      <Seo title={RichText.asText(pricingTitle)} />
      <Flex justifyContent="center">
        <Layout>
          <Header makeBold="Pricing" />
        </Layout>
      </Flex>
      <Layout1
        pricingTitle={RichText.asText(pricingTitle)}
        heroText={RichText.asText(heroText)}
        heroImage={heroImage}
        overview={overview}
        allPriceInfo={allPriceInfo}
      >
        {/*    <RichText className="text-red-700" render={pageTitle} />*/}

        {/*        <h1 className="text-red-700">
        {RichText.asText(pageTitle)}
    </h1>*/}
      </Layout1>
      <SliceZone
        body={props.data.prismic.allPricings.edges[0].node.body}
        allPriceInfo={allPriceInfo}
      />

      <PricingFooter
        allPriceInfo={allPriceInfo}
        heroImage={heroImage}
        allFooterInfo={allFooterInfo}
        allFooterInfoA={allFooterInfoA}
        footerInfo={footerInfo}
      />
      <Layout>
        <Footer />
      </Layout>
    </div>
  );
};

export default Pricing;
